import { render } from "./TheSpinner.vue?vue&type=template&id=aeabeeda&scoped=true"
import script from "./TheSpinner.vue?vue&type=script&lang=ts"
export * from "./TheSpinner.vue?vue&type=script&lang=ts"

import "./TheSpinner.vue?vue&type=style&index=0&id=aeabeeda&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-aeabeeda"

export default script